import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {UserProfileService} from '../services/api/user-profile.service';

export const GbcEntityTypeGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const loggedInUser = inject(UserProfileService).getLoggedInUser();
  const userEntityAllowed = loggedInUser && (loggedInUser.isCustomerUserOrPlatformAdmin() || loggedInUser.isClientUser());
  return userEntityAllowed || router.createUrlTree(
    ['/oauth/green-button-connect/failure'],
    {queryParams: {errorMessageKey: 'gbcCreateSubscriptionPermissionDenied'}}
  );
};
